jQuery(document).ready(function ($) {

	$('.search-button').click(function () {
		$('.header.sticky-container').toggleClass('has-transition-push');
	});
	$('.js-off-canvas-overlay').click(function () {
		$('.header.sticky-container').removeClass('has-transition-push');
	});

	$('a[data-toggle="off-canvas"]').click(function () {
		$('.header.sticky-container').addClass('has-transition-push-left');  // fix for normal hamburger menu
	});

	$('.js-off-canvas-overlay').click(function () {
		$('.header.sticky-container').removeClass('has-transition-push-left');
	});

	$(document).on('click', '.hamburger [aria-expanded="true"]', function () {
		$('.header.sticky-container').removeClass('has-transition-push-left'); // fix for normal hamburger menu
	});

	$('#offCanvasTop').on('opened.zf.offcanvas', function (event) {

		setTimeout(
			function () {
				$('#search-label').click();

			}, 100
		);

	});
});
